// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Wm-z","badgeLink":"Xm-z","category":"Ym-z"};